module.exports = __webpack_public_path__ + "img/yayasan.39c3b721.png";